import React,
{ useEffect, useState, useRef }
 from "react";
import "./Audio.css";
import { connect } from "react-redux";
import { globalStateSelector } from "../../../../../store/selector";
import { globalAction } from "../../../../../store/action";
import { debounce } from "../../../../common/utils";

function Audio({ message, audio_id, dynamicUpdate, currentPlayingAudioRef }) {
	console.log(message, "message content audio before useref")
	// if (!message) {
	// 	return null;
	// }
	// let notRef = new Audio(message.content.link);
	// const audio = useRef(notRef);
	// const [audio, setAudio] = useState(new Audio(message.content.link));
	// const [isPlaying, setIsPlaying] = useState(false);
	// const [percentage, setPercentage] = useState(0);

	// function handleAudioPlayPause() {
	// 	console.log("what is audio???", audio, audio.play);
	// 	if (isPlaying) {
	// 		audio.pause();
	// 		// dynamicUpdate({ key: "currentPlayingAudioRef", value: null} )
	// 		setIsPlaying(false);
	// 	} else {
	// 		// if (currentPlayingAudioRef) {
	// 		// 	currentPlayingAudioRef.pause();
	// 		// 	// dynamicUpdate({ key: "currentPlayingAudioRef", value: null })
	// 		// }
	// 		audio.play();
	// 		// dynamicUpdate({ key: "currentPlayingAudioRef", value: audio })
	// 		setIsPlaying(true);
	// 	}
	// }

	// function handleTimeUpdate(e) {
	// 	setPercentage(e.target.currentTime);
	// }

	// useEffect(() => {
	//   console.log('message audio in useeffect: ', message);
	
	 
	// }, [audio])
	

	// useEffect(() => {
	// 	// if (!audio_id) {
	// 	// 	throw new Error("Audio Id not provided");
	// 	// }


	// 	audio.addEventListener("timeupdate", handleTimeUpdate);

	// 	return () => {
	// 		audio.removeEventListener("timeupdate", handleTimeUpdate)
	// 	}
	// }, [])

	return (
		<React.Fragment>
		{ /*
			<audio id={audio_id}>
			  <source src={message.content.link} />
			  Your browser does not support the audio tag.
			</audio>
		*/ }
			<div className="d-flex w-100">
				<button
					className="material-symbols-outlined"
					// onClick={handleAudioPlayPause}
				>
					{/* {isPlaying ? "play_arrow" : "pause"} */}
				</button>
				<span className="d-inline-block audio-progress-bar">
					{/* <span style={{width: percentage}} className="d-inline-block audio-progress-bar">
					</span> */}
				</span>
				<button className="material-symbols-outlined"></button>
				<button className="material-symbols-outlined"></button>
			</div>
		</React.Fragment>
	);
}


// const stateToProps = (state) => ({
//   currentPlayingAudioRef: globalStateSelector.getDynamic(
// 	  state, 
// 	  { key: 'currentPlayingAudioRef' }
//   )
// });

// const dispatchToProps = (dispatch) => ({
//   dynamicUpdate: (data) => {
//     dispatch(globalAction.dynamicUpdate({ data }));
//   },
// });

// export default connect(stateToProps, dispatchToProps)(Audio);
export default Audio;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/Audio.jsx